import RoleResource from "./role.resource";

const roleModule = angular
  .module("app.resources.role", [])
  .service("Role", RoleResource);

export default roleModule;



// WEBPACK FOOTER //
// ./src/resources/role/role.module.js